import { AnnouncementsTotalPerCustomerListItemModel } from './announcements-total-per-customer-list-item-model';

import { Serializable } from '../../../core/models/serializable';

export class AnnouncementsTotalPerCustomerListModel
  implements Serializable<AnnouncementsTotalPerCustomerListModel>
{
  fromObject(obj: any): AnnouncementsTotalPerCustomerListModel {
    Object.assign(this, obj);
    this.list = [];

    if (obj.list && obj.list.length && obj.list.length > 0) {
      obj.list.forEach((a) => {
        let t = new AnnouncementsTotalPerCustomerListItemModel();
        t = t.fromObject(a);
        this.list.push(t);
      });
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public list: AnnouncementsTotalPerCustomerListItemModel[];
  public groupHeaders: string[];
}
